"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _httpRequestManager = _interopRequireDefault(require("./http-request-manager"));

var _middleware = _interopRequireDefault(require("../middleware"));

var _index = require("../methods/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HttpProvider = function HttpProvider(host, options, store, eventHub) {
  var _this = this;

  _classCallCheck(this, HttpProvider);

  var requestManager = new _httpRequestManager.default(host, options);
  this.httpProvider = {
    send: function send(payload, callback) {
      var req = {
        payload: payload,
        store: store,
        requestManager: requestManager,
        eventHub: eventHub
      };
      var middleware = new _middleware.default();
      middleware.use(_index.ethSendTransaction);
      middleware.use(_index.ethSignTransaction);
      middleware.use(_index.ethGetTransactionCount);
      middleware.use(_index.ethGetTransactionReceipt);
      middleware.use(_index.ethSign);
      middleware.use(_index.personalSign);
      middleware.use(_index.ecRecover);
      middleware.use(_index.ethAccounts);
      middleware.use(_index.ethCoinbase);
      middleware.use(_index.ethGetBlockByNumber);
      middleware.use(_index.ethGetBlockNumber);
      middleware.use(_index.netVersion);
      middleware.use(_index.ethSubscribeBypass);
      middleware.run(req, callback).then(function () {
        requestManager.provider.send(payload, callback);
      });
    },
    notificationCallbacks: [],
    disconnectCallbacks: [],
    closeCallbacks: [],
    accountsChangedCallbacks: [],
    createSubscriptions: function createSubscriptions(subscription) {
      requestManager.addSubscription();
    },
    on: function on(type, callback) {
      if (typeof callback !== 'function') throw new Error('The second parameter callback must be a function.');

      switch (type) {
        case 'data':
          _this.httpProvider.notificationCallbacks.push(callback);

          _this.httpProvider.dataCallback = callback;
          break;
        //
        // case 'connect':
        //   this.connection.onopen = callback;
        //   break;
        //
        // case 'end':
        //   this.connection.onclose = callback;
        //   break;
        //
        // case 'message':
        //   console.log('message callback'); // todo remove dev item
        //   console.log(callback); // todo remove dev item
        //   break;

        case 'accountsChanged':
          _this.httpProvider.accountsChangedCallbacks.push(callback);

          _this.accountsChanged = callback;
          break;

        case 'disconnected':
          _this.httpProvider.disconnectedCallback = callback;
          break;

        case 'disconnect':
          _this.httpProvider.disconnectCallbacks.push(callback);

          _this.httpProvider.disconnectCallback = callback;
          break;

        case 'close':
          _this.httpProvider.closeCallbacks.push(callback);

          _this.httpProvider.closeCallback = callback;
          break;
      }
    },
    emit: function emit(type, data) {
      if (typeof type !== 'string') throw new Error('The first parameter type must be a function.');

      switch (type) {
        case 'accountsChanged':
          _this.httpProvider.accountsChangedCallbacks.forEach(function (callback) {
            if (typeof callback === 'function') callback(data);
          });

          break;
        // case 'disconnected':
        //   this.disconnectedCallback = callback;
        //   break;

        case 'disconnect':
          _this.httpProvider.disconnectCallbacks.forEach(function (callback) {
            if (typeof callback === 'function') callback(data);
          });

          break;

        case 'close':
          _this.httpProvider.closeCallbacks.forEach(function (callback) {
            if (typeof callback === 'function') callback(data);
          });

          break;
      }
    }
  };
  var handler = {
    apply: function apply(target, thisArg, argumentsList) {
      if (argumentsList.length === 1) {
        if (argumentsList[0] === 'eth_requestAccounts' || argumentsList[0] === 'eth_accounts') {
          return new Promise(function (resolve, reject) {
            var callback = function callback(err, response) {
              if (err) reject(err);else resolve(response.result);
            };

            var payload = {
              id: 1,
              method: 'eth_accounts'
            };
            target(payload, callback);
          });
        }
      }

      if (typeof argumentsList[0] === 'string' && typeof argumentsList[1] !== 'function') {
        return new Promise(function (resolve, reject) {
          var callback = function callback(err, response) {
            if (err) reject(err);else resolve(response.result);
          };

          var params = [];

          if (argumentsList.length === 2) {
            params = Array.isArray(argumentsList[1]) ? argumentsList[1] : argumentsList[1] !== undefined ? [argumentsList[1]] : [];
          }

          var payload = {
            jsonrpc: '2.0',
            id: 1,
            method: argumentsList[0],
            params: params
          };
          target(payload, callback);
        });
      }

      return target(argumentsList[0], argumentsList[1]);
    }
  };
  this.httpProvider.send = new Proxy(this.httpProvider.send, handler);
  return this.httpProvider;
};

var _default = HttpProvider;
exports.default = _default;